import { ReactElement } from 'react';
import {
  BulkDeleteWithConfirmButton,
  Datagrid,
  DateField,
  DateInput,
  List,
  SearchInput,
  SelectInput,
  TextField,
  useRecordContext,
} from 'react-admin';

// Function that returns an array of filters in react admin
const getNotificationFilters = (): ReactElement[] => {
  const filters = [
    <SearchInput source="title,text" alwaysOn />,
    <SelectInput
      source="status"
      choices={[
        { id: '0', name: 'Pending' },
        { id: '1', name: 'Processing' },
        { id: '2', name: 'Sent' },
        { id: '3', name: 'Failed' },
      ]}
      alwaysOn
    />,
    <DateInput source="scheduled_at" />,
    <DateInput source="created_at_gte" />,
    <DateInput source="created_at_lte" />,
  ];
  return filters.filter((filter) => filter !== null) as ReactElement[];
};

const NotificationBulkActionButtons = (props: any) => <BulkDeleteWithConfirmButton {...props} />;

// Custom status field component to map status values to labels
const NotificationStatusField = () => {
  const record = useRecordContext();
  if (!record || record.status === undefined) return null;

  const statusMap: Record<number, { label: string; color: string }> = {
    0: { label: 'Pending', color: '#FFC107' }, // Yellow for pending
    1: { label: 'Processing', color: '#2196F3' }, // Blue for processing
    2: { label: 'Sent', color: '#4CAF50' }, // Green for sent
    3: { label: 'Failed', color: '#F44336' }, // Red for failed
  };

  const status = statusMap[record.status] || { label: `Unknown (${record.status})`, color: '#9E9E9E' };

  return (
    <div
      style={{
        backgroundColor: status.color,
        color: 'white',
        borderRadius: '16px',
        padding: '3px 8px',
        fontSize: '0.8125rem',
        display: 'inline-block',
        fontWeight: 500,
      }}
    >
      {status.label}
    </div>
  );
};

export const NotificationList = () => {
  return (
    <List filters={getNotificationFilters()} sort={{ field: 'created_at', order: 'DESC' }}>
      <Datagrid bulkActionButtons={<NotificationBulkActionButtons />} rowClick="show" optimized>
        <TextField source="id" />
        <TextField source="title" />
        <TextField source="text" />
        <NotificationStatusField />
        <DateField source="created_at" showTime />
        <DateField source="updated_at" showTime />
      </Datagrid>
    </List>
  );
};
